import _ from 'lodash'

const history = (data) => {
	const histories = data.map(
		({ id, title: { rendered: title }, content: { rendered: description }, acf: { date } }) => {
			const regx = /<img[^>]+src\s*=\s*['"]([^'"]+)['"][^>]*>/g
			const regSrcset = /srcset\s*=\s*['"]([^'"]+)['"]/g
			const images = description.match(regx)

			const url = description.match(regSrcset)
			const urlsBySize = (!_.isEmpty(url) && url[0].split('"'))[1] || null

			const srcset = (!_.isEmpty(urlsBySize) && urlsBySize.split(' ')[4]) || null

			return {
				id,
				title,
				description,
				date: (date && date.substring(0, 4)) || null,
				image: (!_.isEmpty(images) && images[0]) || null,
				srcset,
			}
		},
	)

	return histories.reverse()
}

export default history
